.placeholder {
  display: grid;
  gap: var(--space-4);
  max-width: 720px;
}

.notFound {
  font: var(--text-headline);
  letter-spacing: var(--tracking-headline);
  color: var(--label);
}

.actions {
  display: flex;
  gap: var(--space-2);
  margin-top: var(--space-4);
}

.stale {
  margin-bottom: var(--space-4);
}
